import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";

import "./assets/styles/style.scss";
import App from "./App";
import {defaultSearcher, SearcherContext} from "./shared/search/components/SearcherContext";
import {SEARCH} from "./shared/config";
import store from "./shared/store";

//import registerServiceWorker from "./registerServiceWorker";

window._$tarQ = window._$tarQ || [];

fetch(
  `${SEARCH.PATH_BASE}/api/init`,
  {
    cache: "no-cache",
    method: "GET"
  },
  data => {
    if (data.csrfToken) {
      store.setItem("SearcherCSRFToken", data.csrfToken);
    }
  }
);

ReactDOM.render(
      <SearcherContext.Provider value={defaultSearcher}>
        <App />
      </SearcherContext.Provider>,
  document.getElementById("root")
);
//registerServiceWorker();
